import { customElement } from 'lit/decorators.js';
import { CSSResultGroup, html } from 'lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import { OutlineElement } from '../../base/outline-element/outline-element';
import headerStyles from '../tufts-header/tufts-header.css.lit';
import componentStyles from './tufts-header-thin.css.lit';

@customElement('tufts-header-thin')
export class TuftsHeaderThin extends OutlineElement {
  static styles: CSSResultGroup = [headerStyles, componentStyles];
  ngSlot = new SlotNGController(this);

  resizeController: ResizeController = new ResizeController(this, {
    breakpoints: [1024],
  });

  isMobile: boolean;

  templateHeaderCTA() {
    return this.isMobile
      ? html` ${this.ngSlot.renderInShadow('header-cta-mobile')} `
      : html` ${this.ngSlot.renderInShadow('header-cta')} `;
  }

  render() {
    this.isMobile = this.resizeController.currentBreakpointRange === 0;
    return html`
      <div class="tufts-main-header ${this.isMobile ? 'mobile' : null}">
        <tufts-container padding="space-0" background-color="white">
          <div class="top-header">
            ${this.ngSlot.renderInShadow('header-logo')}
            ${this.templateHeaderCTA()}
          </div>
        </tufts-container>

        <div id="piwik-consent"></div>
        <div
          id="piwik-consent-band"
          class="piwik-consent-band${this.isMobile ? '-mobile' : null}"
        >
          <div class="piwik-content">
            <span>
              We use <a href="#" id="piwik-consent-band-open">cookies</a> to
              improve your experience on our website. You can learn more about
              what information we collect and how we use it in our
              <a href="/website-privacy-policy">Privacy Policy</a>.
            </span>
            <div class="piwik-cta-container">
              <tufts-button
                button-variant="compact"
                button-url="#"
                button-label="Accept all"
                icon-type=""
                id="piwik-consent-accept"
              >
                Accept all
              </tufts-button>
              <tufts-button
                button-variant="compact"
                button-url="#"
                button-label="Decline all"
                icon-type=""
                id="piwik-consent-decline"
              >
                Decline all
              </tufts-button>
            </div>
          </div>
          <tufts-icon
            id="piwik-consent-band-close"
            name="x"
            library="system"
            size="48px"
          ></tufts-icon>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-header-thin': TuftsHeaderThin;
  }
}
